import React, { FC, HTMLAttributes } from 'react'
import { Box } from '@chakra-ui/core'
import format from 'number-format.js'

interface IProps extends HTMLAttributes<HTMLDivElement> {
  price: number | null
  currency: string
  currencyFormat: string
  discountPrice?: number
  fontSize?: string
}

export const Price: FC<IProps> = ({ price = 0, currency, currencyFormat, discountPrice, fontSize = 'md' }: IProps) => {
  return (
    <Box fontFamily="body" fontSize={fontSize} color="primary.400" d="flex" alignItems="baseline" marginBottom="4px" data-qa-node="price">
      {`${currency} ${format(currencyFormat, discountPrice || price || 0)}`}
      {discountPrice && (
        <Box fontSize="xs" color="white" textDecoration="line-through" marginLeft="4px">
          {`${currency} ${format(currencyFormat, price || 0)}`}
        </Box>
      )}
    </Box>
  )
}
